import sortBy from 'sort-by'
import React, { useContext } from 'react'

import List from '@mui/material/List'

import ProfileContext from '@/components/Context/ProfileContext'
import useBrandsMenu, { parent_id } from '@/lib/hook/useBrandsMenu'
import useCategories from '@/lib/hook/useCategories'
import { Category } from '@/src/types/api-types'
import COLORS from '@/src/colors'

import MainCategory, { CategoryExtended } from './MainCategory'
import { useTheme } from '@mui/material'
import SETTINGS from '@/src/settings'

type Props = {
  mobile?: boolean
}

const CategoryDisplayer: React.FC<Props> = ({ mobile = false }) => {
  const theme = useTheme()
  const { data, isLoading: loading } = useCategories()

  const { profile, isAuthenticated } = useContext(ProfileContext)

  const brandsMenu = useBrandsMenu()

  if (loading || !data) return null

  const listCategories = data

  const rootCategories: CategoryExtended[] = [
    {
      category: t({ id: 'web_marques' }),
      route: 'Brands',
      category_id: String(parent_id),
      position: 0,
    },
    {
      category: 'Tous les produits',
      route: 'AllCategory',
      category_id: '0',
      position: 10,
    },
  ]

  const datas = [...listCategories, ...brandsMenu] as Category[]

  rootCategories.push({
    category: "Centrale d'achat",
    route: 'OctLeader',
    forceColor: COLORS.backgroundBrand,
    position: 30,
    category_id: undefined,
  })

  rootCategories.push({
    category: t({ id: 'web_bestsellers' }),
    route: 'BestSeller',
    forceColor: profile.groupCos ? theme.palette.secondary.main : theme.palette.primary.main,
    position: 40,
    category_id: undefined,
  })

  if (isAuthenticated) {
    rootCategories.push({
      category: t({ id: 'web_promotions' }),
      route: 'Promotions',
      forceColor: theme.palette.secondary.main,
      position: 50,
      category_id: undefined,
    })
  }
  // "Nouveautés" (route NewProduct -> view?mode=new) retiré du menu : fonctionnalité dépréciée
  // (type de bannière N/NEWS déprécié côté CS-Cart).

  const categoriesAntiGaspi = listCategories.find(c => c.category_id === SETTINGS.categoryAntiGaspi)
  rootCategories.push(categoriesAntiGaspi)

  // Menu "Déstockage" basé sur la FEATURE Déstockage (filter_id 13, featuresHash=13-Y),
  // distinct de la catégorie "Bons plans" (1801) qui cible un autre ensemble de produits.
  // DÉSACTIVÉ pour l'instant (disabled: true) : retiré du rendu via le .filter ci-dessous,
  // prêt à activer en passant disabled: false. Gestion back : SearchFacetFilters::getFacetFilters.
  rootCategories.push({
    category: 'Déstockage',
    route: 'Destockage',
    forceColor: '#FF7937',
    position: 35,
    category_id: undefined,
    disabled: true,
  })

  const rootCategoriesSorted = rootCategories
    .filter(c => c && !c.disabled)
    .map(c => {
      return profile.groupCos
        ? {
            ...c,
            forceColor:
              String(c?.category_id) === '1801'
                ? '#FF7937'
                : !c.forceColor
                  ? COLORS.cos.background
                  : c.forceColor,
            position: c.position,
            icon: null,
          }
        : String(c?.category_id) === '1801'
          ? { ...c, forceColor: '#FF7937' }
          : String(c?.category) === t({ id: 'web_otc_leader' })
            ? {
                ...c,
                forceColor: profile.groupLesOfficinales
                  ? COLORS.lesOfficinales.primary
                  : profile.groupCos
                    ? COLORS.cos.primary
                    : COLORS.backgroundBrand,
              }
            : c
    })
    .sort(sortBy('position'))

  if (mobile)
    return (
      <List>
        {rootCategoriesSorted.map(category => (
          <MainCategory key={category.category_id} category={category} categories={datas} mobile />
        ))}
      </List>
    )
  const width = `calc(100% / ${rootCategoriesSorted.length})`

  return (
    <div className="text-base font-semibold whitespace-nowrap w-full flex mb-2">
      {rootCategoriesSorted.map((category, index) => (
        <div style={{ width }} key={category.category_id || index}>
          <MainCategory category={category} categories={datas} />
        </div>
      ))}
    </div>
  )
}

export default CategoryDisplayer
